import type { fabric } from 'fabric';

export interface Bounds {
  left: number;
  top: number;
  width: number;
  height: number;
}

// Axis-aligned box of what the object covers, in slide coordinates
// (independent of the editor zoom).
export const getSlideBounds = (object: fabric.Object): Bounds =>
  object.getBoundingRect(true, true);

export const moveBoundsTo = (
  object: fabric.Object,
  position: { left?: number; top?: number },
) => {
  const bounds = getSlideBounds(object);
  object.set({
    left: (object.left || 0) + (position.left ?? bounds.left) - bounds.left,
    top: (object.top || 0) + (position.top ?? bounds.top) - bounds.top,
  });
  object.setCoords();
};

export const rotateInPlace = (object: fabric.Object, angle: number) => {
  // Fabric rotates around the object's origin (its top-left corner here);
  // keep the center where it was so the object turns in place.
  const center = object.getCenterPoint();
  object.set({ angle: ((angle % 360) + 360) % 360 });
  object.setPositionByOrigin(center, 'center', 'center');
  object.setCoords();
};
